import { Component, effect, inject, OnInit, Provider } from '@angular/core';
import { OrderEditDialogComponent } from 'src/app/patients/dashboard-page/provider-charts-tab/provider-orders-tab/order-edit-dialog/order-edit-dialog.component';
import { PatientDashboardTabComponent } from 'src/app/patients/dashboard-page/dashboard-tab/dashboard-tab.component';
import { ProviderOrder } from 'src/app/calvin-emr-shared/models/provider-order.model';
import { DialogService } from 'primeng/dynamicdialog';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { PROVIDER_ORDERS_FIELD } from 'src/app/global';
import { OrderViewDialogComponent } from './order-view-dialog/order-view-dialog.component';
import { toTitleCase } from 'src/app/shared/utils/string.util';

import { ButtonDirective } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-provider-orders-tab',
  templateUrl: './provider-orders-tab.component.html',
  styleUrls: ['./provider-orders-tab.component.scss'],
  providers: [DialogService],
  standalone: true,
  imports: [
    ButtonDirective,
    TableModule,
    PrimeTemplate,
    TooltipModule
],
})
export class ProviderOrdersTabComponent extends PatientDashboardTabComponent implements OnInit {

  // nonOrderSetProviderOrders: ProviderOrder[] = [];
  allProviderOrders: ProviderOrder[] = [];

  public dialogService = inject(DialogService);

  constructor() {
    super();
    effect(() => {
      this.allProviderOrders = this.patientStore.patient().providerOrders;
      // this.nonOrderSetProviderOrders = patient.providerOrders.filter(po => !po.isInOrderSet);
    });
  }

  ngOnInit(): void { }

  viewOrder(order: ProviderOrder) {
    this.dialogService.open(OrderViewDialogComponent, {
      header: 'View Order',
      data: order,
      width: '50%',
    });
  }

  deleteOrder(order: ProviderOrder) {
    this.allProviderOrders = this.allProviderOrders.filter((o) => {
      return o.id !== order.id;
    });
    this.updatePatientField(PROVIDER_ORDERS_FIELD, this.allProviderOrders);
  }

  openOrderDialog(type: 'create' | 'edit', order?: ProviderOrder) {
    const header = `${toTitleCase(type)} Order`;
    const data = order ?
      {
        type: type,
        order: order,
        forOrderSet: false,
      } :
      {
        type: type,
        forOrderSet: false,
      };

    const dialogRef = this.dialogService.open(OrderEditDialogComponent, {
      header: header,
      width: '90%',
      data: data,
    });

    dialogRef?.onClose.subscribe((order: ProviderOrder) => {
      if (order) {
        if (type === 'create') {
          this.allProviderOrders.push(order);
        } else if (type === 'edit') {
          const indexToRemove = this.allProviderOrders.findIndex((n) => n.id == order.id);
          this.allProviderOrders.splice(indexToRemove, 1, order);
        }

        this.updatePatientField(PROVIDER_ORDERS_FIELD, this.allProviderOrders);
      }
    });
  }
}
